import { Image, View } from 'react-native';
import { IconName } from '@/components/NeolexonIcon/Icons/types';
import { NeolexonIcon } from '@/components/NeolexonIcon';
import { Text } from '@/components/ui/therapist/Text';
import { IS_WEB } from '@/utils/platform';

import colors from '@/config/colors';
import { styles } from '@/components/Pill/styles';

type PillProps = {
  color?: string;
  icon: IconName;
  iconSize?: number;
  isNeolexon: boolean;
  label: string;
};

export const Pill = ({
  color = colors.newUI.therapist.blue60,
  icon,
  iconSize,
  isNeolexon = false,
  label,
}: PillProps) => {
  return (
    <View style={{ display: 'flex', flexDirection: 'row' }}>
      {isNeolexon ? (
        <View style={styles.neolexonIndicator}>
          <Image
            source={require('../../assets/neolexon_white_icon.png')}
            style={{ width: 24, height: 24 }}
            resizeMode="contain"
          />
        </View>
      ) : null}
      <View
        style={[
          styles.labelWrapper,
          IS_WEB && { paddingVertical: 5 },
          { backgroundColor: color },
          isNeolexon && { marginLeft: -20 },
        ]}
      >
        <NeolexonIcon
          size={iconSize}
          name={icon}
          style={{ marginVertical: 5 }}
        />
        <Text style={{ color: 'white', marginLeft: 4 }}>{label}</Text>
      </View>
    </View>
  );
};
